import React, { PureComponent } from 'react';
import Masthead from '../../shared/masthead/index';
import { withApollo } from 'react-apollo';
import { FetchBooking, UpdateSector, UpdateBookingStatus } from '../../../actions/booking';
import { connect } from 'react-redux';
import MapButton from '../../shared/UI/map-button';
import BuilderCard from '../builder/components/builder-card';
import ProductCard from '../builder/components/product-card';
import ExtendCard from '../builder/components/extend-card';
import ItinerarySlidePanel from './components/itinerary-slide-panel';
import { itineraryListData, checkLastItineraryItem } from '../../../helpers/itineraryHelper';
import { pluralHelper } from '../../../helpers/stringutils';
import SpinnerWithBackground from '../../shared/UI/spinner-background';
import ButtonSpinner from '../../shared/UI/button-spinner';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import GapPanel from '../builder/components/gap-panel';
import DestinationPanel from './components/destination-panel';
import { bindActionCreators } from 'redux';
import { ToggleSlidingPanel, ToggleProgressModal, ToggleLockInModal, authToken } from '../../../actions/utils';
import { GetNextDestination } from '../../../actions/cities';
import GapCard from '../builder/components/gap-card';
import { itemProducts } from '../../../helpers/itemsHelper';
import DaySvg from '../../shared/UI/daySvg';
import BedSvg from '../../shared/UI/bedSvg';
import BusSvg from '../../shared/UI/busSvg';
import BagSvg from '../../shared/UI/bagSvg';
import BreadCrumb from '../../shared/breadcrumb';
import PaxButton from '../builder/components/pax-button';
import Sticky from 'react-stickynode';
import ProgressModal from '../../shared/modal/progress-modal';
import LockInModal from '../../shared/modal/lockin-modal';
import { getCyoaName } from '../../../helpers/cyoaHelper';
import { ISOCurrencyCovert } from '../../../helpers/locationHelper';
import { get } from '../../../helpers/objectHelper';
import StickyBookingHighlight from '../views/sticky-booking-highlights';
// import MapBoxWithNoSSR from '../../shared/mapbox/index';
import Spinner from '../../shared/UI/spinner';
import Loadable from 'react-loadable';
import SavePaxModal from '../views/save-pax-modal';
import ReactModal from 'react-modal';
import { AddPassenger } from '../../../actions/passenger';
import Slacklawidget from '../../shared/stackla-widget';
import ExpireModal from '../../shared/modal/expire-modal';

const MapBoxWithNoSSR = Loadable({ loader: () => import('../../shared/mapbox/index'), loading() { return <Spinner loadClass="loading-spinner" />  }});
const queryString = require('query-string');

ReactModal.setAppElement('#root');
dayjs.extend(AdvancedFormat);


class AdventurePlannerItinerary extends PureComponent {

    constructor(props){

        super(props);
        this.state = {
            isSubmitting:false,
            mapActive:false,
            mapStickyEnabled:false,
            stickyBHEnabled:false,
            isUpdating:false,
            showAddGapPanel:false, //toggles next destinations / new sector
            isGapActive:false, //shows and hides 'next destinations / new sector' components 
            showAddPaxModal:queryString.parse(window.location.search).m === '1' ? true : false
        }
        this.mapHandler = this.mapHandler.bind(this);
        this.bookTrip = this.bookTrip.bind(this);
        this.openAccommodationPanel = this.openAccommodationPanel.bind(this);
        this.onExtend = this.onExtend.bind(this);
        this.onAddGap = this.onAddGap.bind(this);
        this.toggleGapActive = this.toggleGapActive.bind(this);
        this.closeAddPaxModal = this.closeAddPaxModal.bind(this);
    }

    showMatrixComponents(){
        //Avoids FOUC on matrix
        if(document.querySelector('#header') !== null) document.querySelector('#header').style.display = "block";
        if(document.querySelector('header') !== null) document.querySelector('header').style.display = "block";
        if(document.querySelector('#contact-top') !== null) document.querySelector('#contact-top').style.display = "block";
        if(document.querySelector('#footer') !== null) document.querySelector('#footer').style.display = "block";
    }

    closeAddPaxModal(){ 
        const { p }  =  queryString.parse(window.location.search);
        window.location.href = `${process.env.REACT_APP_POPULAR_ITINERARY_PAGE}/${p}`;
    }

    componentDidMount(){
        
        //scroll to top
        window.scroll(0,0);

        //check for overflow class
        if(document.querySelector('body').classList.contains('overflow-hidden')){
            document.querySelector('body').classList.remove('overflow-hidden');
        }

        this.init();

    }

    async init(){

        const { client, share } = this.props;
        const { id, m }  =  queryString.parse(window.location.search);

        try{
            // Fetch booking details / Update booking status / Fetch next city destinations
            if(share){
                this.showMatrixComponents();
                await authToken();
                await FetchBooking(client, id);
            }
            if(!share){
                await authToken();
                const {data:{getBooking:{tmsBookingId, uuid, status}}} = await FetchBooking(client, id);

                //Check if booking is cloned
                if(m === "1"){
                    await AddPassenger(client, id, 1);
                    await FetchBooking(client, id);
                }else{
                    this.showMatrixComponents();
                }

                //Check booking for tmsBookingId
                if(tmsBookingId === null){
                    if(status !== "edit") await UpdateBookingStatus(client, uuid, 'edit');
                    await GetNextDestination(client, uuid, 7);
                }
            
                //Set map sticky
                this.setState({
                    mapActive:window.matchMedia("(min-width: 40em)").matches ? true : false, 
                    mapStickyEnabled:window.matchMedia("(min-width: 64em)").matches ? true : false,
                    stickyBHEnabled:window.matchMedia("(min-width: 979px)").matches ? true : false
                });
            }
            
        }catch(e){}
    

    }

    componentWillUnmount(){
        this.setState({isSubmitting:false, mapActive:false, isUpdating:false, showAddGapPanel:false, isGapActive:false});
    }

    mapHandler(){
        this.setState({mapActive: !this.state.mapActive});
    }

    bookTrip(){
        this.props.ToggleLockInModal(true);
    }


    openAccommodationPanel(id, index){

        this.props.ToggleSlidingPanel(false, false, true).then(() => {
           
            //close next destination panel
            if(this.state.isGapActive) this.setState({isGapActive:false});

            document.body.dispatchEvent(new CustomEvent('ITININERARY_SECTOR_CLICK', { detail: {id, index} }));
        });
    }

    onExtend(sectorId, date, nights){

        const {currentBooking:{uuid}, client } = this.props;
        
        this.setState({isUpdating:true});

        UpdateSector(client, uuid, parseInt(sectorId, 10), nights, date).then(()=>{
            this.setState({isUpdating:false});
        });
    }

    renderBuilderCards(data, index){

        switch(data.type){
            case "city":
            case "start":
            case "overnight":    
                return (
                    <BuilderCard 
                        id={'itinerary-view'}
                        showClose={false}
                        showPlus={false}
                        showArrow={true}
                        index={index}
                        builderData={data}
                        onArrowClicked={() => this.openAccommodationPanel(data.id, index)}
                    />
                )
            case "product": 
                return (
                    <ProductCard 
                        id={'itinerary-view'}
                        showClose={false}
                        showPlus={false}
                        showArrow={true}
                        index={index}
                        builderData={data}
                        onArrowClicked={() => this.openAccommodationPanel(data.id, index)}
                    />
                )

            case "extend":
                
                return (
                    <ExtendCard 
                        index={index}
                        builderData={data}
                        onExtendClicked={() => this.onExtend(data.id, data.date, data.nights)}
                        share={this.props.share}
                        />  
                )
            
            case "gap":
                if(data.message === "ACCOMMODATION_GAP"){
                    return (
                        <ExtendCard 
                            index={index}
                            builderData={data}
                            onExtendClicked={() => this.onExtend(data.id, data.date, data.nights)}
                            share={this.props.share}
                            />  
                    )
                } 

                return <GapCard index={index} share={this.props.share} />
           
            default:
                return (
                    <BuilderCard 
                        id={'itinerary-view'}
                        showClose={false}
                        showPlus={false}
                        showArrow={true}
                        index={index}
                        builderData={data}
                        onArrowClicked={() => this.openAccommodationPanel(data.id, index)}
                    />
                )       
        }
    }

    renderDestinationAndGap(){
        
        const {currentBooking:{status} } = this.props;
        const { showAddGapPanel, isGapActive } = this.state;

        if(status !== "confirmed" && status !== "checkout"){
            return (
                !showAddGapPanel ? 
                <li className={`builder-list-item`}><DestinationPanel toggleGapActive={this.toggleGapActive} isGapActive={isGapActive} /></li> : 
                <li className="builder-list-item"><GapPanel onCloseClicked={this.onAddGap} /></li>
            )
        }else{
            return null;
        }
    }

    onAddGap(){
        this.setState({showAddGapPanel: !this.state.showAddGapPanel});
    }

    toggleGapActive(){

        const { client, currentBooking:{uuid} } = this.props;

        this.setState({isGapActive: !this.state.isGapActive}, () => {
            if(this.state.isGapActive){
                //Fetch next city destinations
                GetNextDestination(client, uuid, 7);
            }
        });
    }
    
    render(){

        
        const { mapActive, isSubmitting, isUpdating, showAddGapPanel, mapStickyEnabled, stickyBHEnabled, showAddPaxModal } = this.state;
        const { itinerary, filteredItinerary, prices, currentBooking:{items, status, iso_currency }, slidePanelActive, nextDestinations:{routes}, share  } = this.props;
        
        const _itinerary = (itinerary === undefined) ? [] : itinerary;

        const parsed = (typeof window !== 'undefined') ? queryString.parse(window.location.search) : {};
        
        if(_itinerary.length === 0){
            return (
                <>
                <SpinnerWithBackground text="Loading itinerary..." bgClass="no-opacity" loadClass="orange-spinner-wrapper"/>
                <ExpireModal />    
                </>
            ) 
        }else{ 
                      
            const _numPasseger = get([0, 'passengers'], items, "");
            const _prices = (prices !== undefined) ? prices : "";
    
            const { startCity, lastCity, accommodationNight:_numNights, date } = itineraryListData(0, _itinerary);
            const _itemProducts = itemProducts(items);


            let _itineraryImage = get([0, 'cityInfo', 'hero', 0], _itinerary, "");
            if(_itineraryImage === "/" || _itineraryImage === "")  _itineraryImage = "//images.ctfassets.net/3ng3kfj0qs70/63YK66Gae5JSfEnGkPbUUr/05c4f3ec6f64c4b41008442106a46232/Grand_Canyon.jpg";

            const _mapBoxSequence = (_itinerary !== undefined && _itinerary.length > 0) ? _itinerary : [];
            const _tripStart = (get([0, 'nights'], _itinerary, null) === null) ? dayjs(date).format("Do MMMM YYYY") : dayjs(date).add(_itinerary[0].nights,'days').format("Do MMMM YYYY");
            const _tripDeparture = get([1, 'departure'],filteredItinerary, "");
            const { meta:{stops, trips, days} } = this.props;

            return (
                <>
                    <Masthead isItinerary={true} image={_itineraryImage} isShare={share} />
                    
                    <div className="max-width-5 mx-auto margin-t-50 margin-b-300 masthead-body">
                    
                        <MapButton mapHandler={this.mapHandler} active={mapActive} />
                        <Sticky enabled={stickyBHEnabled} activeClass={"sticky-bh-active"}>{ status => { if (status.status === Sticky.STATUS_FIXED) return <StickyBookingHighlight view={"itinerary"} showAddGapPanel={showAddGapPanel} clickHandler={this.bookTrip} isSubmitting={isSubmitting} isShare={share}  /> }}</Sticky>
                        <div className={`${mapActive ? "clearfix" : ""}`} id="itinerary-container">
                            <div className={`${mapActive ? "col col-12 lg-col-6 px2" : ""}`}>
                                <div className="clearfix booking-highlight">
                                    <div className={`${mapActive ? "col-12 mx-auto" : "col-12 sm-col-9 md-col-7 mx-auto" }`}>

                                    <BreadCrumb view={"itinerary"} type={"ap"} />   

                                        <div className="clearfix margin-t-20">
                                            
                                            <div className="col col-12 px2">
                                                
                                                <h3 className="block busabout-h3 no-margin">{startCity} to {lastCity}</h3>
                                                {
                                                    _itemProducts.map((item, index)=>{
                                                        return (
                                                            <h5 className="block busabout-h5 viking-text mt1" key={index}>
                                                                <svg className="ml1" width="12" height="12" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path fill="#3ABCCB" d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"></path></svg>
                                                                {item.name}
                                                            </h5>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>

                                        <div className="lg-flex clearfix icon-container margin-t-20 margin-b-20">    
                                            <div className="lg-flex col col-12 sm-col-8 px2 items-center">
                                                <DaySvg clazz={"mr1"} /> <span className="bold mr2">{days} days</span>
                                                <BedSvg clazz={"mr1"} /> <span className="bold mr2">{_numNights} nights </span>
                                                <BusSvg clazz={"mr1"} /> <span className="bold mr2">{stops} stops</span>
                                                { trips > 0 && <><BagSvg clazz={"mr1"} /> <span className="bold mr2">{trips} trips</span></> }
                                            </div>

                                            <div className="lg-flex col col-12 sm-col-4 justify-end px2">
                                                { (status !== "checkout")  && <PaxButton isShare={share} />}
                                            </div>
                                        </div>   

                                        <div className="clearfix">   
                                            <div className="col col-12 px2">
                                                <p className="description-text margin-b-20">
                                                {days} day custom trip, including {_numNights} nights accommodation    
                                                {trips > 0 && <span> plus {trips} add-on trip </span>}
                                                for {_numPasseger} {pluralHelper('adult', _numPasseger)}. Trip starts in {startCity}, where 
                                                <span className="bold"> Busabout guide will meet and greet on the {_tripStart} {_tripDeparture !== "" && `at ${_tripDeparture}`}.</span>
                                                </p>
                                            </div>    
                                        </div>            

                                    </div>
                                </div>

                                <div className="clearfix">
                                    <div className={`${mapActive ? "col-12 mx-auto" : "col-12 sm-col-10 md-col-8 px2 mx-auto"}`}>
                    
                                        <ul className="builder-list itinerary-list">
                                        { 
                                            _itinerary.map((data, index) => {

                                                //Cache-bust newly added/removed images
                                                const renderKey = !isUpdating ? index : Math.random();

                                                //conditional class value for product/city and extends
                                                const itineraryDataType = (index !== 0 && data.type === "start") ? 'gap-start' : data.type;
                                                const preGapType = ((data.type === "city" || data.type === "start" || data.type === "product") && _itinerary[ index < _itinerary.length -1  ? index + 1 : 0].type === "gap") ? 'pre-gap' : '';
                                                const doubleGapType = (itineraryDataType === "gap-start" && _itinerary[ index < _itinerary.length -1  ? index + 1 : 0].type === "gap") ? 'pre-gap' : '';
                                                const productCityOrExtends = (data.type !== "extend") ? `builder-list-item builder-list-item-card ${itineraryDataType} ${preGapType} ${doubleGapType} ${(filteredItinerary.length === index + 1 )? 'last': ''} ` : `extend-list-item`;
                                                return <li key={renderKey} className={`${productCityOrExtends} ${mapActive ? 'mapactive' : ''}`}> { this.renderBuilderCards(data, index) }</li>
                                            })
                                        }


                                        { !share && this.renderDestinationAndGap() }

                                        </ul>

                                        {
                                        (((!showAddGapPanel) || checkLastItineraryItem(_itinerary, routes)) && (status !== "confirmed" && status !== "checkout" && !share)  )  && <button className="agent-portal-grey busabout--cta--link center block col-12" onClick={this.onAddGap}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="18" height="18" className="mr2">
                                                <path fill="#808080" d="M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zM148 320h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 96h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm192 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12z"/>
                                            </svg>
                                            Add <span className="bold">new destinatons</span> and <span className="bold">start date to create</span> gaps in itinerary
                                        </button>
                                        }   
                                    </div>
                                </div>

                        
                                <div className="clearfix">
                                    <div className="mx-auto col-12 px2 margin-t-50 margin-b-40 center">
                                        <p className="uppercase bold f-size-14">
                                            { (status !== 'confirmed') && ('Total price')  }
                                            { (status === 'confirmed') && ('Total due')  }
                                        </p>

                                        <p className="orange-text bold f-size-30 margin-b-10">
                                            { (status !== "confirmed") && (`${ISOCurrencyCovert(iso_currency).props.children}${parseFloat(_prices.total).toFixed(2)}`) }
                                            { (status === "confirmed") && (`${ISOCurrencyCovert(iso_currency).props.children}${parseFloat(_prices.due).toFixed(2)}`) }
                                            <span className="f-size-14 uppercase">{iso_currency}</span>
                                        </p>
                                        <p className="description-text margin-b-20">Booking {_numPasseger} {pluralHelper("traveller", _numPasseger)} for {days} days including {_numNights} {pluralHelper("night", _numNights)}  accommodation</p>
                                        <button className={`busabout--cta rounded-corner ${((share && status === "confirmed") ||  (!share && status === "confirmed")  ) ? 'green-background' : 'orange'}  ${ (share || (!share && status === "confirmed") ) ? 'no-pointer-event': ''}`} onClick={this.bookTrip} disabled={itinerary !== undefined && (stops || 0) >= 1 ? false : true}>
                                            { 
                                                !isSubmitting && (
                                                    <>
                                                    { (!share && status !== "confirmed") && ('Book now') }
                                                    { (!share && status === "confirmed") && ('Confirmed') }
                                                    { (share && status !== "confirmed") && ('Your Quote') }
                                                    { (share && status === "confirmed") && ('Confirmed') }
                                                    </> 
                                                )
                                            }
                                            { isSubmitting &&  <ButtonSpinner /> } 
                                        </button>
                                        { (share && status !== "confirmed") && <p className="f-size-12 mt2">Please notify us if you are happy with the quote and want to proceed with booking.</p> }
                                    </div>
                                </div>
                            

                            </div>

                            <div className={`${mapActive ? "col col-12 lg-col-6 px2" : ""}`}>
                            { mapActive &&  <Sticky enabled={mapStickyEnabled} top={90} bottomBoundary='#itinerary-container' innerZ={999998}><MapBoxWithNoSSR destination={getCyoaName(parsed)} countriesShow={_mapBoxSequence} clickable={true} isItinerary={true} openPanel={this.openAccommodationPanel} id={"mapContainer"} /></Sticky> } 
                            </div> 

                        </div>

                        <div className="clearfix margin-t-100">
                            <div className="col-12 md-col-10 lg-col-9 mx-auto px2 center margin-b-70">
                                <h3 className="font-proxima-nova text-initial h2">Real and genuine moments <span className="bold">captured by our travellers</span></h3>
                                <p className="mt3 col-12 md-col-10 lg-col-6 mx-auto">Instagram moments to make your friends jealous on this trip.</p>
                            </div>
                            <Slacklawidget />
                        </div> 

                    </div>
                    
           


                    { slidePanelActive && <ItinerarySlidePanel share={share} /> }
                    { !share && <ProgressModal /> }
                    { !share && <LockInModal /> }
                    { 
                            showAddPaxModal && (
                                <ReactModal
                                    className="youtube-modal"
                                    overlayClassName="modal-overlay white"
                                    isOpen={showAddPaxModal}
                                    contentLabel="Youtube modal">
                                    <div className="max-width-5 mx-auto clearfix">

                                        <div className="col col-12 px2">
                                            <div className="youtube-content pax-modal">
                                                <SavePaxModal />
                                            </div>
                                        </div>

                                    </div>
                                    <button className="close-button left" type="button" onClick={this.closeAddPaxModal}></button>
                                </ReactModal>
                            )
                    }
                    { !share && <ExpireModal /> }   
                </>
            )
        }    
    }
}



const mapStateToProps = state => {
    return{
        prices:state.currentBooking.prices,
        itinerary:state.currentBooking.itinerary,
        filteredItinerary:state.currentBooking.filteredItinerary,
        currentBooking:state.currentBooking,
        meta:state.currentBooking.meta,
        passengers:state.currentBooking.passengers,
        slidePanelActive:state.toggleSlidePanel.itineraryIsOpen,
        nextDestinations:state.nextDestinations,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        ToggleSlidingPanel,
        ToggleProgressModal,
        ToggleLockInModal
    }, dispatch);
}
  

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(AdventurePlannerItinerary));